/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const assessmentApi = platform.learningPanel.AssessmentsAPIs;
const getUncompletedAssessments = 'uncompleted-assessments';
const getAssessmentsResults = 'assessments-results';

export const useGetUncompletedAssessments = (enableQuery = true) => {
    return useQuery([getUncompletedAssessments], () => assessmentApi.getUncompletedAssessments(), {
        cacheTime: 0,
        enabled: enableQuery
    });
};

export const useGetAssessmentsResults = () => {
    return useQuery([getAssessmentsResults], () => assessmentApi.getAssessmentsResults());
};
